/**
 * @param preferenceCenterForm {HTMLFormElement}
 * @return {HTMLInputElement}
 */
module.exports = function getPreferenceCenterFormEmailInput(preferenceCenterForm) {
    const emailInput = preferenceCenterForm.querySelector('[name="email"]');

    if (emailInput instanceof HTMLInputElement) {
        return emailInput;
    }

    throw new Error("getPreferenceCenterFormEmailInput: no email input found!");
}